import { call, put } from 'redux-saga/effects';
import { getAllDCListSuccess, getAllDCListFailure } from '../components/search-dc/redux/actions';
import SearchDCInputService from '../components/search-dc/SearchDCInputService';

const searchDCInputService = new SearchDCInputService();

function* loadAllDCList() {
    try {
        const DCList = yield call(searchDCInputService.getDCs);
        const modifiedDCList = DCList.map(DC => ({
            name: DC.dcName,
            code: DC.dcCode
           
        }))
        yield put(getAllDCListSuccess(modifiedDCList));
    } catch(error) {
        yield put(getAllDCListFailure(error.toString()));
    }
}

export { loadAllDCList };